import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {getLocale} from "@karpeleslab/klbfw";
import moment from "moment";

const locale = getLocale().split('-')[0];
if (locale !== 'en')
    require('moment/locale/' + locale);

moment.locale(locale);

const Date = ({variant, ...props}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
            <DatePicker {...props} />
        </LocalizationProvider>
    );
};

export default Date;
